<template>
  <div id="About" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">A</span>cerca</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 mt8 pl8 pr8">
      <div class="col-12 mt30 mb30 t-c">
        <img src="../../assets/pos.jpg" alt="" class="w10 r5">
      </div>
      <div class="col-12 t-c color-muted">
        Versión: {{$store.state.set.app_ver}}
      </div>
      <!--
      <div class="col-12 t-c mt20">
        <button @click="test_print">Test Print</button>
      </div>

      <div class="col-12 t-c mt20">
        <button @click="createPasskey">Create Passkey</button>
      </div>
      <div class="col-12 t-c mt20">
        <button @click="verifyPasskey">Verify Passkey</button>
      </div>  
            -->
    </div>
  </div>
</template>

<script>
async function connectToBluetoothDevice(deviceId = null){
  if (!navigator.bluetooth || !navigator.bluetooth.requestDevice){
    alert("Your device does not support the Web Bluetooth API. Try again on Chrome on Desktop or Android!");
  }
  else {
    try {
      let device;
      const savedDeviceId = localStorage.getItem('bluetoothDeviceId');
      if (savedDeviceId) {
        // Try to connect to the saved device
        device = await navigator.bluetooth.getDevices({ filters: [{ id: deviceId }] });
        if (device.length === 0) {
          throw new Error('No saved device found');
        }
        device = device[0];
      } else {
        // Request a new device
        device = await navigator.bluetooth.requestDevice({
          acceptAllDevices: true,
          optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb']
        });
        //将设备ID保存到data中
        // Save the device ID to local storage
        //alert('Device ID: ' + device.id);
        localStorage.setItem('bluetoothDeviceId', device.id);
      }

      const server = await device.gatt.connect();
      const service = await server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb");
      const characteristic = await service.getCharacteristic("00002af1-0000-1000-8000-00805f9b34fb");
      // Check if the characteristic supports write operation
      if (characteristic.properties.write) {
        // Print test text
        const encoder = new TextEncoder();
        const data = encoder.encode('Hello, Bluetooth Printer!');
        await characteristic.writeValue(data);
        //打印二维码
        const data2 = encoder.encode('Hello, Bluetooth Printer!');
        await characteristic.writeValue(data2);
        await device.gatt.disconnect();
        alert('Print command sent successfully!');

      } else {
        alert('The characteristic does not support write operation.');
      }
    } catch (error) {
      console.error('Failed to connect to the device:', error);
      alert('Failed to connect to the device: ' + error.message);
    }
  }
}
function generateRandomChallenge() {
    let length = 32;
    let randomValues = new Uint8Array(length);
    window.crypto.getRandomValues(randomValues);
    return randomValues;
}
async function createPasskey(){
  if (!navigator.credentials || !navigator.credentials.create || !navigator.credentials.get){
    return alert("Your browser does not support the Web Authentication API");
  }
  
  // 创建凭证
  let credentials = await navigator.credentials.create({
      publicKey: {
        // 生成随机挑战
        challenge: generateRandomChallenge(),
        // 可信方信息
        rp: { name: "POS", id: window.location.hostname },
        // 用户信息
        user: { id: new Uint8Array(16), name: "johndoe@example.com", displayName: "John Doe"},
        // 公钥凭证参数
        pubKeyCredParams: [
            { type: "public-key", alg: -7 },
            { type: "public-key", alg: -257 }
        ],
        // 超时时间
        timeout: 60000,
        // 认证器选择
        authenticatorSelection: {residentKey: "preferred", requireResidentKey: false, userVerification: "preferred"},
        // 声明
        attestation: "none",
        // 扩展
        extensions: { credProps: true }
      }
  });
  //in a real app, you'll store the credentials against the user's profile in your DB
  //here we'll just save it in a global variable
  window.currentPasskey = credentials;
  //credentials为object,弹出所有的对象

}
async function verifyPasskey(){
  try {
    //to verify a user's credentials, we simply pass the 
    //unique ID of the passkey we saved against the user profile
    //in this demo, we just saved it in a global variable
    let credentials = await navigator.credentials.get({
        publicKey: {
          challenge: generateRandomChallenge(),
          allowCredentials: [{ type: "public-key", id: window.currentPasskey.rawId }]
        }
    });
    //alert(JSON.stringify(credentials)); 
    alert("Biometric authentication successful!");
  }
  catch(err){
    alert(err);
  }
}
export default {
  name: 'About',
  data () {
    return {
      device_id: null
    }
  },
  created: function () {
    //清空
    localStorage.removeItem('bluetoothDeviceId');
    /*
    const savedDeviceId = localStorage.getItem('bluetoothDeviceId');
    if (savedDeviceId) {
      alert(savedDeviceId);
      connectToBluetoothDevice(savedDeviceId);
    }
      */
  },
  methods: {
    createPasskey() {
      createPasskey();
    },
    verifyPasskey() {
      verifyPasskey();
    },
    //test bluetooth printer
    test_print() {
      connectToBluetoothDevice();
    },
    onDecode(result) {
      alert('Barcode decoded: ' + result);
      console.log(result);
    },
    onLoaded() {
      alert('Barcode reader loaded');
    },
    save: function () {
      if(this.password != this.re_password || this.password == ''){
        return false;
      }
      let post_data = {}
      post_data.password = this.password
      this.post(this.api_url + 'Agent/account_safety_update',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.$router.back(-1);
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Main/About.vue